import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';

export default class DropdownsWeeksComponent extends Component {
  @service store;

  @tracked textFilter = '';

  tippyInstance = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get trigger() {
    return this.args?.trigger ?? '';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? false;
  }

  get currentWeek() {
    const weeks = this.store
      .peekAll('week')
      .filter((item) => item.get('initiative.id') === this.args.initiative);
    const currentWeek = weeks.filter((item) => item.isCurrentWeek);
    if (currentWeek.length > 0) return currentWeek[0];
    else return null;
  }

  get searchable() {
    const weeks = this.store
      .peekAll('week')
      .filter((item) => item.get('initiative.id') === this.args.initiative);
    return weeks?.length > 6;
  }

  @action
  onWeekSelect(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
  }

  get weeksList() {
    const weeks = this.store
      .peekAll('week')
      .filter((item) => item.get('initiative.id') === this.args.initiative);
    return !this.textFilter
      ? weeks
      : weeks.filter(
          (item) =>
            item.title.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
            0,
        );
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  loadWeeks() {
    if (this.args.initiative === undefined) return;
    const initiative = this.store.peekRecord(
      'initiative',
      this.args.initiative,
    );
    initiative?.get('weeks');
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }
}
